// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Link-module--cds--assistive-text--394bf";
export var cdsVisuallyHidden = "Link-module--cds--visually-hidden--c1036";
export var hideFeedback = "Link-module--hide-feedback--f7121";
export var link = "Link-module--link--2c220";
export var showFeedback = "Link-module--show-feedback--1485f";
export var skeleton = "Link-module--skeleton--be46c";